exports.REGISTRY_ITEMS = {
	applications: Object.freeze({
		app_icpm: Object.freeze({
			id: "app_icpm",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/icpm/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anzeigenportfolio/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_icpm"),
		}),
		app_ioca: Object.freeze({
			id: "app_ioca",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/ioca/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/anzeigenerfassung",
					"/anzeigenerfassung/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () => await import("app_ioca"),
		}),
		app_ioca_dispatcher: Object.freeze({
			id: "app_ioca_dispatcher",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/ioca_dispatcher/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/dispatcher", "/dispatcher/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () => await import("app_ioca_dispatcher"),
		}),
		app_iprf: Object.freeze({
			id: "app_iprf",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/iprf/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/iprf/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/profil/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_iprf"),
		}),
		app_conp_dashboard: Object.freeze({
			id: "app_conp_dashboard",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/conp_dashboard/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/meineimmobilien/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_dashboard"),
		}),
		app_conp_estimationPage: Object.freeze({
			id: "app_conp_estimationPage",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/conp_estimationPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/meineschaetzungen/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_estimationPage"),
		}),
		app_esfu_estimaLandingPage: Object.freeze({
			id: "app_esfu_estimaLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_esfu_addressEntryPoint: Object.freeze({
					server: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
					client: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/esfu_estimaLandingPage/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/esfu_estimaLandingPage/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienbewertung"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_esfu_estimaLandingPage"),
		}),
		app_fsbo: Object.freeze({
			id: "app_fsbo",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/fsbo/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/eigentuemer/anzeigenerfassung/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () => await import("app_fsbo"),
		}),
		app_fsbo_depositFunnelLandingFrboCommercial: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboCommercial",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboCommercial/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboCommercial/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/buero-vermieten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboCommercial"),
		}),
		app_fsbo_depositFunnelLandingFrboFlats: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboFlats",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboFlats/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboFlats/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/wohnung-vermieten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboFlats"),
		}),
		app_fsbo_depositFunnelLandingFrboGeneric: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboGeneric",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboGeneric/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboGeneric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/immobilien-vermieten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboGeneric"),
		}),
		app_fsbo_depositFunnelLandingFrboHouses: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboHouses",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboHouses/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboHouses/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/haus-vermieten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboHouses"),
		}),
		app_fsbo_depositFunnelLandingFrboMarketing: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboMarketing",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboMarketing/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboMarketing/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/kampagnen/privat-vermieten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboMarketing"),
		}),
		app_fsbo_depositFunnelLandingFrboPlots: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboPlots",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboPlots/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFrboPlots/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/grundstueck-verpachten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboPlots"),
		}),
		app_fsbo_depositFunnelLandingFsboFlats: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsboFlats",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboFlats/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboFlats/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/wohnung-verkaufen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsboFlats"),
		}),
		app_fsbo_depositFunnelLandingFsboGeneric: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsboGeneric",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboGeneric/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboGeneric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/immobilien-verkaufen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsboGeneric"),
		}),
		app_fsbo_depositFunnelLandingFsboHouses: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsboHouses",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboHouses/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboHouses/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/haus-verkaufen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsboHouses"),
		}),
		app_fsbo_depositFunnelLandingFsboPlots: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsboPlots",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboPlots/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsboPlots/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/grundstueck-verkaufen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsboPlots"),
		}),
		app_fsbo_depositFunnelLandingFsrboCommercial: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsrboCommercial",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboCommercial/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboCommercial/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/gewerbeimmobilien"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsrboCommercial"),
		}),
		app_fsbo_depositFunnelLandingFsrboFlats: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsrboFlats",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboFlats/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboFlats/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/wohnung-inserieren"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsrboFlats"),
		}),
		app_fsbo_depositFunnelLandingFsrboGeneric: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsrboGeneric",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboGeneric/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/fsbo_depositFunnelLandingFsrboGeneric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/immobilienanzeigen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsrboGeneric"),
		}),
		app_owcl_contact: Object.freeze({
			id: "app_owcl_contact",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/owcl_contact/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/kontaktanfragen/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owcl_contact"),
		}),
		app_owcl_myListings: Object.freeze({
			id: "app_owcl_myListings",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/owcl_myListings/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/nutzerportal/meine-anzeigen/*",
					"/nutzerportal/meine-anzeige/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owcl_myListings"),
		}),
		app_owpp_houseValuationLandingPage: Object.freeze({
			id: "app_owpp_houseValuationLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_houseValuationLandingPage/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_houseValuationLandingPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/hausbewertung"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_owpp_houseValuationLandingPage"),
		}),
		app_owpp_houseValueLandingPage: Object.freeze({
			id: "app_owpp_houseValueLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_houseValueLandingPage/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_houseValueLandingPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/hauswert-ermitteln"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owpp_houseValueLandingPage"),
		}),
		app_owpp_marketValueLandingPage: Object.freeze({
			id: "app_owpp_marketValueLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_marketValueLandingPage/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_marketValueLandingPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/verkehrswert-immobilie"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owpp_marketValueLandingPage"),
		}),
		app_owpp_nutzungsdauerLandingPage: Object.freeze({
			id: "app_owpp_nutzungsdauerLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_nutzungsdauerLandingPage/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_nutzungsdauerLandingPage/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzungsdauer-gutachten"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_owpp_nutzungsdauerLandingPage"),
		}),
		app_owpp_offerSelection: Object.freeze({
			id: "app_owpp_offerSelection",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/owpp_offerSelection/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/angebot-auswahl/privatkunden",
					"/angebot-auswahl/gewerblichekunden",
				]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "minimal",
			testing: Object.freeze([]),
			loader: async () => await import("app_owpp_offerSelection"),
		}),
		app_owpp_postPayment: Object.freeze({
			id: "app_owpp_postPayment",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/owpp_postPayment/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/abrechnung/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owpp_postPayment"),
		}),
		app_owpp_realEstateValueLandingPage: Object.freeze({
			id: "app_owpp_realEstateValueLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_realEstateValueLandingPage/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_realEstateValueLandingPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/immobilienwert-ermitteln"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_owpp_realEstateValueLandingPage"),
		}),
		app_owpp_sellHouseLandingPage: Object.freeze({
			id: "app_owpp_sellHouseLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/owpp_sellHouseLandingPage/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/owpp_sellHouseLandingPage/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten/verkaufen"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_owpp_sellHouseLandingPage"),
		}),
		app_pric: Object.freeze({
			id: "app_pric",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_pricePagesAgencyCards: Object.freeze({
					client: "https://www.immowelt.de/assets/mfes/avis_pricePagesAgencyCards/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/pric/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/pric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienpreise/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_pric"),
		}),
		app_cmsg_inbox: Object.freeze({
			id: "app_cmsg_inbox",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/cmsg_inbox/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/inbox/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_cmsg_inbox"),
		}),
		app_paym_payment: Object.freeze({
			id: "app_paym_payment",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/paym_payment/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/zahlung/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "minimal",
			testing: Object.freeze([]),
			loader: async () => await import("app_paym_payment"),
		}),
		app_cads_mobileDownloadLandingPage: Object.freeze({
			id: "app_cads_mobileDownloadLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/cads_mobileDownloadLandingPage/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/cads_mobileDownloadLandingPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/app-herunterladen"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_cads_mobileDownloadLandingPage"),
		}),
		app_cldp: Object.freeze({
			id: "app_cldp",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_esfu_addressEntryPoint: Object.freeze({
					server: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
					client: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/cldp/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/cldp/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/expose/:classifiedId",
					"/projekte/expose/:classifiedId",
					"/projekte/expose-preview/:classifiedId",
					"/wl-cdp/:classifiedId",
					"/cdp-preview/:classifiedId",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_cldp"),
		}),
		app_conp_seeker: Object.freeze({
			id: "app_conp_seeker",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/conp_seeker/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/meinbereich/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_seeker"),
		}),
		app_home_main: Object.freeze({
			id: "app_home_main",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_agencyInTheSpotlight: Object.freeze({
					client: "https://www.immowelt.de/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/home_main/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/home_main/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_home_main"),
		}),
		app_home_newbuilds: Object.freeze({
			id: "app_home_newbuilds",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/home_newbuilds/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/home_newbuilds/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/projekte/suche/"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_home_newbuilds"),
		}),
		app_hpfn_financingFunnel: Object.freeze({
			id: "app_hpfn_financingFunnel",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/hpfn_financingFunnel/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/hpfn_financingFunnel/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienfinanzierung-anfragen/*"]),
				type: "client",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () => await import("app_hpfn_financingFunnel"),
		}),
		app_serp: Object.freeze({
			id: "app_serp",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_adimsxl: Object.freeze({
					client: "https://www.immowelt.de/assets/mfes/avis_adimsxl/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/serp/v2/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/serp/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/suche/*", "/classified-search"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp"),
		}),
		app_serp_map: Object.freeze({
			id: "app_serp_map",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/serp_map/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/classified-map"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp_map"),
		}),
		app_serp_project: Object.freeze({
			id: "app_serp_project",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/apps/serp_project/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/apps/serp_project/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/project-search",
					"/suche/:location/neubauprojekte",
					"/suche/:part1/:part2/neubau/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp_project"),
		}),
		app_skpf_seeker: Object.freeze({
			id: "app_skpf_seeker",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/skpf_seeker/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/meinprofil/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "minimal",
			testing: Object.freeze([]),
			loader: async () => await import("app_skpf_seeker"),
		}),
		app_ssal_savedSearchManagement: Object.freeze({
			id: "app_ssal_savedSearchManagement",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/ssal_savedSearchManagement/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/gespeicherte-suchen"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_ssal_savedSearchManagement"),
		}),
		app_ssal_savedSearchUnsubscribed: Object.freeze({
			id: "app_ssal_savedSearchUnsubscribed",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/apps/ssal_savedSearchUnsubscribed/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/nutzerportal/gespeicherte-suche-deaktivieren",
					"/list-unsub",
				]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_ssal_savedSearchUnsubscribed"),
		}),
	}),
	microFrontends: Object.freeze({
		mfe_avis_adimsxl: Object.freeze({
			id: "mfe_avis_adimsxl",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/mfes/avis_adimsxl/v1/client/remoteEntry.js",
			}),
		}),
		mfe_avis_agencyInTheSpotlight: Object.freeze({
			id: "mfe_avis_agencyInTheSpotlight",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
			}),
		}),
		mfe_avis_pricePagesAgencyCards: Object.freeze({
			id: "mfe_avis_pricePagesAgencyCards",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immowelt.de/assets/mfes/avis_pricePagesAgencyCards/v1/client/remoteEntry.js",
			}),
		}),
		mfe_esfu_addressEntryPoint: Object.freeze({
			id: "mfe_esfu_addressEntryPoint",
			type: "micro_frontend",
			rendering: "server",
			version: 1,
			urls: Object.freeze({
				server: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
				client: "https://www.immowelt.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
			}),
		}),
	}),
};
